import { isThisLevelSectionWrapped } from './isThisLevelSectionWrapped';
import { CaseGranulometry } from '../../domain/granulometry/cases/CaseGranulometry';
import { getCaseLevels } from '../../domain/granulometry/cases/queries/levels/getCaseLevels';

export const isAnyCaseLevelSectionWrapped = (caseGranulometry: CaseGranulometry): boolean =>
  getCaseLevels(caseGranulometry).some(isThisLevelSectionWrapped);
